// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : payload value passing method change
// MODIFIED DATE : 31-07-2025
import { takeLatest, put, all, call } from 'redux-saga/effects';

import RoleActionTypes from './role.types';
import {
	roleDetailsAdd,
	roleDetailsUpdate,
	roleListGet,
	roleDetailsFetch,
	roleDetailsDelete,
} from './role.service';
import AlertManager from '../../../utils/alertManager';

import {
	addRoleDetailsSuccess,
	addRoleDetailsFailure,
	addRoleDetailsResponseChanged,
	updateRoleDetailsSuccess,
	updateRoleDetailsFailure,
	updateRoleDetailsResponseChanged,
	getRoleListSuccess,
	getRoleListFailure,
	getRoleListResponseChanged,
	fetchRoleDetailsSuccess,
	fetchRoleDetailsFailure,
	fetchRoleDetailsResponseChanged,
	deleteRoleDetailsSuccess,
	deleteRoleDetailsFailure,
	deleteRoleDetailsResponseChanged,
} from './role.action';
import { encryptData } from '../../_common/enode-decode';

/** *********************  START GET ROLE LIST  ******************** */
export function* roleDetailsListGet({ payload }: any) {
	try {
		const key = 'GetRoleListKey';
		const { companyID, databaseName, inputSearch, limit } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			InputSearch: inputSearch,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(roleListGet, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			yield put(getRoleListFailure(responseData.data));
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getRoleListFailure(responseData.data));
		} else {
			yield put(getRoleListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getRoleListFailure(error));
	}
}

export function* resetGetRoleListResponse() {
	yield put(getRoleListResponseChanged());
}

export function* onGetRoleListDetails() {
	yield takeLatest(RoleActionTypes.GET_ROLE_LIST_START, roleDetailsListGet);
}

export function* onGetRoleListResponseReset() {
	yield takeLatest(RoleActionTypes.GET_ROLE_LIST_RESPONSE_RESET, resetGetRoleListResponse);
}
/** *********************  END GET ROLE LIST ******************** */

/** *********************  START ADD ROLE DETAILS  ******************** */
export function* createRole({ payload }: any) {
	try {
		const key = 'AddRoleDetailKey';
		const {
			isFunder,
			roleName,
			roleLevel,
			companyID,
			databaseName,
			userAccessBranchID,
			userName,
			userID,
			generalCompanyID,
		} = payload;

		let setIsFunder = 0;
		if (isFunder === true) {
			setIsFunder = 1;
		}
		const jsonData = {
			RoleName: roleName,
			RoleLevel: roleLevel,
			IsFunder: setIsFunder,
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
			CreatedBy: userID,
			GeneralCompanyID: generalCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(roleDetailsAdd, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addRoleDetailsFailure(responseData.data));
		} else {
			yield put(addRoleDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addRoleDetailsFailure(error));
	}
}

export function* resetAddRoleResponse() {
	yield put(addRoleDetailsResponseChanged());
}

export function* onCreateRoleDetails() {
	yield takeLatest(RoleActionTypes.ADD_ROLE_DETAILS_START, createRole);
}

export function* onCreateRoleResponseReset() {
	yield takeLatest(RoleActionTypes.ADD_ROLE_DETAILS_RESPONSE_RESET, resetAddRoleResponse);
}
/** *********************  END ADD ROLE DETAILS ******************** */

/** *********************  START UPDATE ROLE DETAILS  ******************** */
export function* roleUpdate({ payload }: any) {
	try {
		const key = 'UpdateRoleDetailsKey';
		let setIsFunder = 0;
		const {
			isFunder,
			roleID,
			roleName,
			roleLevel,
			oldRoleName,
			oldRoleLevel,
			companyID,
			databaseName,
			userAccessBranchID,
			userName,
			userID,
		} = payload;

		if (isFunder === true) {
			setIsFunder = 1;
		}
		const jsonData = {
			RoleID: roleID,
			RoleName: roleName,
			RoleLevel: roleLevel,
			OldRoleName: oldRoleName,
			OldRoleLevel: oldRoleLevel,
			IsFunder: setIsFunder,
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
			CreatedBy: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(roleDetailsUpdate, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateRoleDetailsFailure(responseData.data));
		} else {
			yield put(updateRoleDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateRoleDetailsFailure(error));
	}
}

export function* resetUpdateRoleDetailsResponse() {
	yield put(updateRoleDetailsResponseChanged());
}

export function* onUpdateRoleDetails() {
	yield takeLatest(RoleActionTypes.UPDATE_ROLE_DETAILS_START, roleUpdate);
}

export function* onUpdateRoleResponseReset() {
	yield takeLatest(
		RoleActionTypes.UPDATE_ROLE_DETAILS_RESPONSE_RESET,
		resetUpdateRoleDetailsResponse,
	);
}
/** *********************  END UPDATE ROLE DETAILS ******************** */

/** *********************  START DELETE ROLE DETAILS  ******************** */
export function* roleDelete({ payload }: any) {
	try {
		const key = 'DeleteRoleDetailsKey';
		const { companyID, roleID, roleName, databaseName, userID, userAccessBranchID, userName } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			RoleID: roleID,
			RoleName: roleName,
			DatabaseName: databaseName,
			DeletedBy: userID,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(roleDetailsDelete, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteRoleDetailsFailure(responseData.data));
		} else {
			yield put(deleteRoleDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteRoleDetailsFailure(error));
	}
}

export function* resetDeleteRoleDetailsResponse() {
	yield put(deleteRoleDetailsResponseChanged());
}

export function* onDeleteRoleDetail() {
	yield takeLatest(RoleActionTypes.DELETE_ROLE_DETAILS_START, roleDelete);
}

export function* onDeleteRoleResponseReset() {
	yield takeLatest(
		RoleActionTypes.DELETE_ROLE_DETAILS_RESPONSE_RESET,
		resetDeleteRoleDetailsResponse,
	);
}
/** *********************  END DELETE ROLE DETAILS ******************** */

/** *********************  START FETCH ROLE DETAILS  ******************** */
export function* fetchRoleData({ payload }: any) {
	try {
		const key = 'FetchRoleDetailsKey';
		const { companyID, roleID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			RoleID: roleID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(roleDetailsFetch, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchRoleDetailsFailure(responseData.data));
		} else {
			yield put(fetchRoleDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchRoleDetailsFailure(error));
	}
}

export function* resetFetchRoleDetailsResponse() {
	yield put(fetchRoleDetailsResponseChanged());
}

export function* onFetchRoleDetails() {
	yield takeLatest(RoleActionTypes.FETCH_ROLE_DETAILS_START, fetchRoleData);
}

export function* onFetchRoleResponseReset() {
	yield takeLatest(
		RoleActionTypes.FETCH_ROLE_DETAILS_RESPONSE_RESET,
		resetFetchRoleDetailsResponse,
	);
}
/** *********************  END FETCH ROLE DETAILS ******************** */

export function* roleMasterSaga() {
	yield all([
		call(onCreateRoleDetails),
		call(onCreateRoleResponseReset),
		call(onUpdateRoleDetails),
		call(onUpdateRoleResponseReset),
		call(onGetRoleListDetails),
		call(onGetRoleListResponseReset),
		call(onFetchRoleDetails),
		call(onFetchRoleResponseReset),
		call(onDeleteRoleDetail),
		call(onDeleteRoleResponseReset),
	]);
}
